export function canHideNode(nodes) {
    return [...nodes].filter(
        node => this.actions.canHideNode(node)
    )
}

export async function hideNode(nodes) {
    await this.execute(
        () => this.actions.hideNode(nodes)
    )
}
